// Values for these constants are taken from the documentations
// and verified in the source of the library
// Valid OS names - https://github.com/bowser-js/bowser/blob/master/src/constants.js
export const ParserOSNames = {
    Android: 'Android',
    IOS: 'iOS',
    Windows: 'Windows',
    MacOS: 'macOS',
    Linux: 'Linux',
};
// Valid OS names - https://github.com/bowser-js/bowser/blob/master/src/constants.js
export const ParserDeviceTypes = {
    Mobile: 'mobile',
};
// https://html.spec.whatwg.org/multipage/system-state.html#dom-navigator-vendor
export const WEBKIT_NAVIGATOR_VENDOR = 'Apple Computer, Inc.';
// Only Gecko has this property, so it identifies the engine whatever the user agent says
export const GECKO_WINDOW_PROPERTY = 'mozInnerScreenX';
